import { useNavigate } from 'react-router-dom'

import { NAV_GROUPS, navItemHref } from '@/components/layout/navItems'
import { Button } from '@/components/ui/Button'

/**
 * "전체 보기"·"공지·홍보 관리"·"정산 상세 보기" 공용 — `CardHeader` 의 `action` 슬롯에 쓴다.
 *
 * 🚨 활성/비활성 판정은 `navItems.ts` 하나로 통일한다(설계 §2-1(e) 자율 결정 5) — 사이드바가
 * `planned` 항목을 링크로 만들지 않는 것과 같은 이유, 같은 규칙이다. 목적지 화면이 `ready` 로
 * 바뀌는 순간 이 버튼도 코드 변경 없이 함께 열린다.
 */
export function DashboardSectionLink({
  venueId,
  path,
  label,
}: {
  venueId: string
  path: string
  label: string
}) {
  const navigate = useNavigate()
  const item = NAV_GROUPS.flatMap((group) => group.items).find((candidate) => candidate.path === path)

  if (!item || item.status === 'planned') {
    return (
      <span
        aria-disabled="true"
        className="cursor-not-allowed rounded-full bg-slateish-200 px-2.5 py-1 text-xs text-slateish-600"
      >
        준비 중
      </span>
    )
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => {
        navigate(navItemHref(venueId, item))
      }}
    >
      {label}
    </Button>
  )
}
